import React from 'react';

const NoMatch = () => (
  <h2>No Match</h2>
);

export default NoMatch;
